<template>
  <div class="bg-white overflow-hidden relative flex flex-col">
    <main class="flex-1 overflow-y-auto hide-scrollbar p-5 space-y-5 pb-tabbar-safe">
      <section class="animate-slide-up space-y-4 mb-1" style="animation-delay: 0.1s">
        <div class="flex justify-between items-start mb-0">
          <h2 class="text-black text-3xl font-black italic">
            {{ totalData[0]?.inProgressTotal[1].value }}
            <span class="text-sm not-italic font-bold text-gray-400">AOP</span>
          </h2>
          <div class="flex flex-col items-end">
            <div class="w-44 mt-1 -ml-2 mr-7">
              <div class="relative">
                <van-slider
                  v-model="sliderRange"
                  :min="0"
                  :max="3"
                  :step="1"
                  range
                  :bar-height="7"
                  :button-size="16"
                  active-color="#000000"
                  inactive-color="#E5E7EB"
                  class="relative z-10"
                  @drag-start="onSliderStart"
                  @drag-end="onSliderEnd"
                >
                  <template #left-button>
                    <div class="w-4 h-4 bg-white border-2 border-black rounded-[9999px] shadow"></div>
                  </template>
                  <template #right-button>
                    <div class="w-4 h-4 bg-white border-2 border-black rounded-[9999px] shadow"></div>
                  </template>
                </van-slider>
              </div>
              <div class="flex justify-between text-xs text-gray-500 mt-1 tracking-wide">
                <span>Q1</span>
                <span>Q2</span>
                <span>Q3</span>
                <span>Q4</span>
              </div>
            </div>
            <p class="text-orange-500 text-3xl font-black italic">{{ totalData[0]?.inProgressTotal[0]?.value }}<span class="text-base text-gray-400 pl-1">({{ formatPercent(totalData[0]?.inProgressTotal?.[0]?.value, totalData[0]?.inProgressTotal?.[1]?.value) }}%)</span></p>
            <p class="text-gray-400 text-[10px] font-bold uppercase">Total Progress</p>
          </div>
        </div>
        <div class="flex gap-3 items-center">
          <div class="relative h-40 w-2/3 flex items-center justify-center">
            <div class="absolute inset-0 -top-4" ref="chartEl"></div>
            <div class="text-center z-10">
              <p class="text-[14px] font-bold text-gray-400 uppercase leading-none">Opened</p>
              <p class="text-2xl font-black italic text-black">{{ totalData[0]?.inProgressTotal[0]?.openedNum }}</p>
              <p class="text-[12px] font-bold text-green-600 uppercase">{{ formatPercent(totalData[0]?.inProgressTotal[0]?.openedNum, totalData[0]?.inProgressTotal?.[1]?.value) }}%</p>
            </div>
          </div>
          <div class="h-30 w-1/3 shrink-0 flex flex-col items-end justify-around gap-3">
            <div class="flex flex-col items-end">
              <p class="text-blue-500 text-3xl font-black italic">{{ totalData[0]?.inProgressTotal[0]?.inProgress }}<span class="text-base text-gray-400 pl-1">({{ formatPercent(totalData[0]?.inProgressTotal?.[0]?.inProgress, totalData[0]?.inProgressTotal?.[1]?.value) }}%)</span></p>
              <p class="text-gray-400 text-[10px] font-bold uppercase">In Progress</p>
            </div>
            <div class="flex flex-col items-end">
              <p class="text-black text-3xl font-black italic">{{ totalData[0]?.timeProgress }}%</p>
              <p class="text-gray-400 text-[10px] font-bold uppercase">Time Progress</p>
            </div>
          </div>
        </div>
      </section>
      <section class="space-y-2 animate-slide-up mb-3" style="animation-delay: 0.2s">
        <h3 class="text-black text-sm font-bold uppercase tracking-wider">Progress Overview</h3>
        <div class="bg-white rounded-2xl p-3 border border-gray-100 shadow-sm space-y-2">
          <div class="flex justify-between items-center">
            <span class="px-2 py-0.5 bg-black text-white text-[10px] font-bold rounded">KEY DOOR</span>
          </div>
          <div class="grid grid-cols-3 gap-2">
            <div class="bg-gray-50 p-1 rounded-lg border border-gray-100">
              <p class="text-[8px] text-green-700 font-bold uppercase">Opened</p>
              <p class="text-xs text-green-700 font-bold italic">{{ totalData[2]?.inProgressTotal[0]?.openedNum }}<span class="text-[9px] text-gray-400 pl-1">({{ formatPercent(totalData[2]?.inProgressTotal?.[0]?.openedNum, totalData[2]?.inProgressTotal?.[1]?.value) }}%)</span></p>
            </div>
            <div class="bg-blue-50 p-1 rounded-lg border border-blue-100">
              <p class="text-[8px] text-blue-600 font-bold uppercase">In Progress</p>
              <p class="text-xs font-black italic text-blue-700">{{ totalData[2]?.inProgressTotal?.[0]?.inProgress }}<span class="text-[9px] text-gray-400 pl-1">({{ formatPercent(totalData[2]?.inProgressTotal?.[0]?.inProgress, totalData[2]?.inProgressTotal?.[1]?.value) }}%)</span></p>
            </div>
            <div class="bg-orange-50 p-1 rounded-lg border border-orange-100">
              <p class="text-[8px] text-orange-700 font-bold uppercase">Total</p>
              <p class="text-xs font-black italic text-orange-600">{{ totalData[2]?.inProgressTotal?.[0]?.value }}<span class="text-[9px] text-gray-400 pl-1">({{ formatPercent(totalData[2]?.inProgressTotal?.[0]?.value, totalData[2]?.inProgressTotal?.[1]?.value) }}%)</span></p>
            </div>
          </div>
          <div class="relative h-2 w-full bg-gray-100 rounded-2xl overflow-hidden flex">
            <div class="h-full bg-green-500" :style="{ width: formatPercent(totalData[2]?.inProgressTotal?.[0]?.openedNum, totalData[2]?.inProgressTotal?.[1]?.value) + '%' }"></div>
            <div class="h-full bg-blue-400" :style="{ width: formatPercent(totalData[2]?.inProgressTotal?.[0]?.inProgress, totalData[2]?.inProgressTotal?.[1]?.value) + '%', borderRadius: '0 16px 16px 0' }"></div>
          </div>
        </div>
        <div class="bg-white rounded-2xl p-3 border border-gray-100 shadow-sm space-y-2">
          <div class="flex justify-between items-center">
            <span class="px-2 py-0.5 bg-black text-white text-[10px] font-bold rounded">NON KEY DOOR</span>
          </div>
          <div class="grid grid-cols-3 gap-2">
            <div class="bg-gray-50 p-1 rounded-lg border border-gray-100">
              <p class="text-[8px] text-green-700 font-bold uppercase">Opened</p>
              <p class="text-xs text-green-700 italic">{{ totalData[1]?.inProgressTotal[0]?.openedNum }}<span class="text-[9px] text-gray-400 pl-1">({{ formatPercent(totalData[1]?.inProgressTotal?.[0]?.openedNum, totalData[1]?.inProgressTotal?.[1]?.value) }}%)</span></p>
            </div>
            <div class="bg-blue-50 p-1 rounded-lg border border-blue-100">
              <p class="text-[8px] text-blue-600 font-bold uppercase">In Progress</p>
              <p class="text-xs font-black italic text-blue-700">{{ totalData[1]?.inProgressTotal[0]?.inProgress }}<span class="text-[9px] text-gray-400 pl-1">({{ formatPercent(totalData[1]?.inProgressTotal?.[0]?.inProgress, totalData[1]?.inProgressTotal?.[1]?.value) }}%)</span></p>
            </div>
            <div class="bg-orange-50 p-1 rounded-lg border border-orange-100">
              <p class="text-[8px] text-orange-700 font-bold uppercase">Total</p>
              <p class="text-xs font-black italic text-orange-600">{{ totalData[1]?.inProgressTotal[0]?.value }}<span class="text-[9px] text-gray-400 pl-1">({{ formatPercent(totalData[1]?.inProgressTotal?.[0]?.value, totalData[1]?.inProgressTotal?.[1]?.value) }}%)</span></p>
            </div>
          </div>
          <div class="relative h-2 w-full bg-gray-100 rounded-2xl overflow-hidden flex">
            <div class="h-full bg-green-500" :style="{ width: formatPercent(totalData[1]?.inProgressTotal?.[0]?.openedNum, totalData[1]?.inProgressTotal?.[1]?.value) + '%' }"></div>
            <div class="h-full bg-blue-400" :style="{ width: formatPercent(totalData[1]?.inProgressTotal?.[0]?.inProgress, totalData[1]?.inProgressTotal?.[1]?.value) + '%', borderRadius: '0 16px 16px 0' }"></div>
          </div>
        </div>
        <div class="bg-white rounded-2xl p-3 border border-gray-100 shadow-sm space-y-2">
          <div class="flex justify-between items-center">
            <span class="px-2 py-0.5 bg-gray-200 text-gray-600 text-[10px] font-bold rounded uppercase">TOP DOOR</span>
          </div>
          <div class="grid grid-cols-3 gap-2">
            <div class="bg-gray-50 p-1 rounded-lg border border-gray-100">
              <p class="text-[8px] text-green-700 font-bold uppercase">Opened</p>
              <p class="text-xs text-green-700 italic">{{ totalData[3]?.inProgressTotal[0]?.openedNum }}<span class="text-[9px] text-gray-400 pl-1">({{  formatPercent(totalData[3]?.inProgressTotal[0]?.openedNum, totalData[3]?.inProgressTotal?.[1]?.value)  }}%)</span></p>
            </div>
            <div class="bg-blue-50 p-1 rounded-lg border border-blue-100">
              <p class="text-[8px] text-blue-600 font-bold uppercase">In Progress</p>
              <p class="text-xs font-black italic text-blue-700">{{ totalData[3]?.inProgressTotal[0]?.inProgress }}<span class="text-[9px] text-gray-400 pl-1">({{ formatPercent(totalData[3]?.inProgressTotal[0]?.inProgress, totalData[3]?.inProgressTotal?.[1]?.value) }}%)</span></p>
            </div>
            <div class="bg-orange-50 p-1 rounded-lg border border-orange-100">
              <p class="text-[8px] text-orange-700 font-bold uppercase">Total</p>
              <p class="text-xs font-black italic text-orange-600">{{ totalData[3]?.inProgressTotal[0]?.value }}<span class="text-[9px] text-gray-400 pl-1">({{ formatPercent(totalData[3]?.inProgressTotal[0]?.value, totalData[3]?.inProgressTotal?.[1]?.value) }}%)</span></p>
            </div>
          </div>
          <div class="relative h-2 w-full bg-gray-100 rounded-2xl overflow-hidden flex">
            <div class="h-full bg-green-500" :style="{ width: formatPercent(totalData[3]?.inProgressTotal?.[0]?.openedNum, totalData[3]?.inProgressTotal?.[1]?.value) + '%' }"></div>
            <div class="h-full bg-blue-400" :style="{ width: formatPercent(totalData[3]?.inProgressTotal?.[0]?.inProgress, totalData[3]?.inProgressTotal?.[1]?.value) + '%', borderRadius: '0 16px 16px 0' }"></div>
          </div>
        </div>
      </section>
      <h3 class="text-black text-sm font-bold uppercase tracking-wider mb-2">Account Breakdown</h3>
      <section class="px-3 mb-4 animate-slide-up" style="animation-delay: 0.6s">
        <div class="grid grid-cols-[2fr_1fr_1.5fr_1fr] gap-x-2 text-[10px] font-bold uppercase text-gray-400">
          <span>Account</span>
          <span class="text-right whitespace-nowrap">Opened</span>
          <span class="text-right whitespace-nowrap">N6/K3 In Progress</span>
          <span class="text-right whitespace-nowrap">Total</span>
        </div>
        <div v-if="fourPartsLoading" class="py-4 text-center text-xs text-gray-400">Loading...</div>
        <div v-else>
          <div
            v-for="row in visibleRows"
            :key="row.id"
            class="grid grid-cols-[2fr_1fr_1.5fr_1fr] gap-x-2 items-center py-2 border-b border-gray-100 text-sm"
            :style="{ paddingLeft: row.level ? row.level * 12 + 'px' : undefined }"
            @click="row.hasChildren && toggleRow(row)"
          >
            <div class="flex items-center gap-1">
              <van-icon
                v-if="row.hasChildren"
                :name="expandedIds.has(row.id) ? 'arrow-down' : 'arrow'"
                size="12"
                class="text-gray-500"
              />
              <span :class="[ row.level === 0 ? 'text-black font-bold' : 'text-gray-700' ]">{{ row.group }}</span>
            </div>
            <div class="text-right text-green-600 font-black whitespace-nowrap">{{ row.openedNum }}</div>
            <div class="text-right text-blue-500 font-black whitespace-nowrap">{{ row.inProgress }}</div>
            <div class="text-right text-orange-500 font-black whitespace-nowrap">{{ row.total }}</div>
          </div>
          <div v-if="!visibleRows.length" class="py-4 text-center text-xs text-gray-400">No Data</div>
        </div>
      </section>
      <h3 class="text-black text-sm font-bold uppercase tracking-wider mb-2">Gate Approval Overview</h3>
      <section class="px-3 mb-4 animate-slide-up" style="animation-delay: 0.4s">
        <div class="grid grid-cols-[2fr_1fr_1fr_1fr] gap-x-2 text-[10px] font-bold uppercase text-gray-400">
          <span>Gate</span>
          <span class="text-right whitespace-nowrap">On Track</span>
          <span class="text-right whitespace-nowrap">Overdue</span>
          <span class="text-right whitespace-nowrap">Total</span>
        </div>
        <div v-if="fullGateLoading" class="py-4 text-center text-xs text-gray-400">Loading...</div>
        <div v-else>
          <div
            v-for="(g, i) in fullGateRows"
            :key="i"
            class="grid grid-cols-[2fr_1fr_1fr_1fr] gap-x-2 items-center py-2 border-b border-gray-100 text-sm"
          >
            <div class="text-black">{{ g.name }}</div>
            <div class="text-right text-blue-500 font-black whitespace-nowrap">{{ g.onTrack }}</div>
            <div class="text-right text-red-500 font-black whitespace-nowrap">{{ g.overDue }}</div>
            <div class="text-right text-orange-500 font-black whitespace-nowrap">{{ g.total }}</div>
          </div>
          <div v-if="!fullGateRows.length" class="py-4 text-center text-xs text-gray-400">No Data</div>
        </div>
      </section>
      <h3 class="text-black text-sm font-bold uppercase tracking-wider mb-2">Concept Breakdown</h3>
      <section class="px-3 mb-4 animate-slide-up" style="animation-delay: 0.6s">
        <div class="grid grid-cols-[2fr_1fr_1.5fr_1fr] gap-x-2 text-[10px] font-bold uppercase text-gray-400">
          <span>Concept</span>
          <span class="text-right whitespace-nowrap">Opened</span>
          <span class="text-right whitespace-nowrap">N6/K3 In Progress</span>
          <span class="text-right whitespace-nowrap">Total</span>
        </div>
        <div v-if="conceptLoading" class="py-4 text-center text-xs text-gray-400">Loading...</div>
        <div v-else>
          <div
            v-for="row in conceptVisibleRows"
            :key="row.id"
            class="grid grid-cols-[2fr_1fr_1.5fr_1fr] gap-x-2 items-center py-2 border-b border-gray-100 text-sm"
            :style="{ paddingLeft: row.level ? row.level * 12 + 'px' : undefined }"
            @click="row.hasChildren && toggleConceptRow(row)"
          >
            <div class="flex items-center gap-1">
              <van-icon
                v-if="row.hasChildren"
                :name="conceptExpandedIds.has(row.id) ? 'arrow-down' : 'arrow'"
                size="12"
                class="text-gray-500"
              />
              <span :class="[ row.level === 0 ? 'text-black font-bold' : 'text-gray-700' ]">{{ row.group }}</span>
            </div>
            <div class="text-right text-green-600 font-black whitespace-nowrap">{{ row.openedNum }}</div>
            <div class="text-right text-blue-500 font-black whitespace-nowrap">{{ row.inProgress }}</div>
            <div class="text-right text-orange-500 font-black whitespace-nowrap">{{ row.total }}</div>
          </div>
          <div v-if="!conceptVisibleRows.length" class="py-4 text-center text-xs text-gray-400">No Data</div>
        </div>
      </section>
    </main>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref, watch, nextTick, computed } from 'vue'
import * as echarts from 'echarts'
import { getNspInProgressFourParts, getNspInProgressFullGate, getTotal } from '@/api/dashboard'
import { getCurrentUser, permitAccount } from '@/api/login'

const chartEl = ref<HTMLDivElement | null>(null)
let chart: any = null
let resizeHandler: any = null

const quarters = ['Q1', 'Q2', 'Q3', 'Q4']
const selectedQuarters = ref<string[]>([])
const sliderRange = ref<[number, number]>([0, 0])
const isDragging = ref(false)

/** 获取年份，若当前月份在 6 月之前，则返回当前年份，否则返回下一年 */
function getNextYearIfAfterJune() {
  const now = new Date()
  const currentMonth = now.getMonth() + 1
  return currentMonth < 6 ? now.getFullYear() : now.getFullYear() + 1
}

const debounce = <T extends (...args: any[]) => any>(fn: T, delay = 300) => {
  let timer: any
  return (...args: Parameters<T>) => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}

const rangeOfQuarter = (q: string, baseYear: number) => {
  if (q === 'Q1') return { s: `${baseYear}-06-01`, e: `${baseYear}-08-31` }
  if (q === 'Q2') return { s: `${baseYear}-09-01`, e: `${baseYear}-11-30` }
  if (q === 'Q3') {
    const y = baseYear + 1
    const febLast = ((y % 4 === 0 && y % 100 !== 0) || y % 400 === 0) ? 29 : 28
    return { s: `${baseYear}-12-01`, e: `${y}-02-${febLast}` }
  }
  const y = baseYear + 1
  return { s: `${y}-03-01`, e: `${y}-05-31` }
}

/** 确保选中的季度是连续的 */
const ensureContiguous = (qs: string[]) => {
  if (qs.length === 0) return [] as string[]
  const idx = qs.map((q) => quarters.indexOf(q)).filter((i) => i >= 0)
  const min = Math.min(...idx)
  const max = Math.max(...idx)
  const res: string[] = []
  for (let i = min; i <= max; i++) res.push(quarters[i]!)
  return res
}

const isLocked = (q: string) => {
  if (selectedQuarters.value.length < 2) return false
  const idxs = selectedQuarters.value.map((x) => quarters.indexOf(x))
  const min = Math.min(...idxs)
  const max = Math.max(...idxs)
  const i = quarters.indexOf(q)
  return i > min && i < max
}

const computeRange = (qs: string[]) => {
  const year = getNextYearIfAfterJune()
  if (qs.length === 0) return { yearFront: '', yearEnd: '' }
  const ids = qs.map((q) => quarters.indexOf(q)).filter((i) => i >= 0)
  const min = Math.min(...ids)
  const max = Math.max(...ids)
  const startQ = quarters[min]
  const endQ = quarters[max]
  const start = rangeOfQuarter(startQ!, year - 1).s
  const end = rangeOfQuarter(endQ!, year - 1).e
  return { yearFront: start, yearEnd: end }
}

/**
 * @description 保留一位小数
 * @param num 被除数
 * @param den 除数
 */
const formatPercent = (num?: number, den?: number) => {
  const n = Number(num ?? 0)
  const d = Number(den ?? 0)
  if (!d) return '0'
  const v = (n / d) * 100
  const r = Math.round(v * 10) / 10
  return Number.isInteger(r) ? String(r) : r.toFixed(1)
}

const getChartOption = () => {
  const opened = Number(totalData.value?.[0]?.inProgressTotal?.[0]?.openedNum ?? 0)
  const inProgress = Number(totalData.value?.[0]?.inProgressTotal?.[0]?.inProgress ?? 0)
  const total = Number(totalData.value?.[0]?.inProgressTotal?.[1]?.value ?? 0)
  const remaining = Math.max(total - opened - inProgress, 0)
  return {
    series: [
      {
        type: 'pie',
        radius: ['65%', '90%'],
        avoidLabelOverlap: false,
        itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
        label: { show: false },
        data: [
          { value: opened, name: 'Opened', itemStyle: { color: '#00C950' } },
          { value: inProgress, name: 'InProgress', itemStyle: { color: '#50A2FF' } },
          { value: remaining, name: 'Remaining', itemStyle: { color: '#F3F4F6' } },
        ],
      },
    ],
  }
}

const renderChartFromTotal = () => {
  if (!chart && chartEl.value) {
    chart = echarts.init(chartEl.value)
  }
  if (!chart) return
  chart.setOption(getChartOption())
}

type FourPartNode = {
  id: string
  group: string
  openedNum: number
  inProgress: number
  children?: FourPartNode[]
}
type DisplayRow = {
  id: string
  level: number
  group: string
  openedNum: number
  inProgress: number
  total: number
  hasChildren: boolean
}

const totalData = ref<any[]>([])
const fourPartsLoading = ref(false)
const fourPartsData = ref<FourPartNode[]>([])
const expandedIds = ref<Set<string>>(new Set())
const conceptLoading = ref(false)
const conceptData = ref<FourPartNode[]>([])
const conceptExpandedIds = ref<Set<string>>(new Set())
const fullGateLoading = ref(false)
const fullGateData = ref<any[]>([])

const normalizeFourParts = (items: any[], path = ''): FourPartNode[] => {
  if (!Array.isArray(items)) return []
  const filtered = items.filter((it: any) => {
    const name = String(it?.group ?? '').trim().toLowerCase()
    return name !== 'total'
  })
  return filtered.map((it: any, idx: number) => {
    const id = path ? `${path}-${idx}` : `${idx}`
    const childrenRaw = it?.children || []
    const node: FourPartNode = {
      id,
      group: String(it?.group ?? ''),
      openedNum: Number(it?.openedNum ?? 0),
      inProgress: Number(it?.inProgress ?? 0),
      children: normalizeFourParts(childrenRaw, id),
    }
    return node
  })
}

const flattenVisible = (nodes: FourPartNode[], expanded: Set<string>, level = 0): DisplayRow[] => {
  const rows: DisplayRow[] = []
  for (const n of nodes) {
    rows.push({
      id: n.id,
      level,
      group: n.group,
      openedNum: n.openedNum,
      inProgress: n.inProgress,
      total: (Number(n.openedNum) || 0) + (Number(n.inProgress) || 0),
      hasChildren: !!(n.children && n.children.length),
    })
    if (n.children && n.children.length && expanded.has(n.id)) {
      rows.push(...flattenVisible(n.children, expanded, level + 1))
    }
  }
  return rows
}

const visibleRows = computed<DisplayRow[]>(() => flattenVisible(fourPartsData.value, expandedIds.value))
const conceptVisibleRows = computed<DisplayRow[]>(() => flattenVisible(conceptData.value, conceptExpandedIds.value))

const toggleRow = (row: DisplayRow) => {
  if (!row.hasChildren) return
  const s = new Set(expandedIds.value)
  if (s.has(row.id)) s.delete(row.id)
  else s.add(row.id)
  expandedIds.value = s
}

const toggleConceptRow = (row: DisplayRow) => {
  if (!row.hasChildren) return
  const s = new Set(conceptExpandedIds.value)
  if (s.has(row.id)) s.delete(row.id)
  else s.add(row.id)
  conceptExpandedIds.value = s
}

const fullGateRows = computed(() =>
  fullGateData.value.map((it: any) => ({
    name: String(it?.name ?? ''),
    onTrack: Number(it?.onTrack ?? 0),
    overDue: Number(it?.overDue ?? 0),
    total: Number(it?.onTrack ?? 0) + Number(it?.overDue ?? 0),
  }))
)

const computeAccountArray = () => {
  const raw = String(sessionStorage.getItem('user_account_group') || '').trim()
  if (!raw) return []
  const lower = raw.toLowerCase()
  return raw.split(',').map((s) => s.trim()).filter(Boolean)
}

const triggerApis = async () => {
  const { yearFront, yearEnd } = computeRange(selectedQuarters.value)
  const year = getNextYearIfAfterJune()
  const payload = {
    doorType: 'All',
    yearFront,
    yearEnd,
    year,
    account: computeAccountArray(),
  }
  try {
    const res = await getTotal(payload)
    totalData.value = (Array.isArray(res?.data) ? res?.data : res?.data?.items) || []
    renderChartFromTotal()
  } catch {}
  try {
    fourPartsLoading.value = true
    conceptLoading.value = true
    fullGateLoading.value = true
    const [fourRes, conceptRes, fullRes] = await Promise.all([
      getNspInProgressFourParts({ ...payload, type: 'Account' }),
      getNspInProgressFourParts({ ...payload, type: 'Concept' }),
      getNspInProgressFullGate(payload),
    ])
    const raw = (Array.isArray(fourRes?.data) ? fourRes?.data : fourRes?.data?.items) || []
    fourPartsData.value = normalizeFourParts(raw)
    const conceptRaw = (Array.isArray(conceptRes?.data) ? conceptRes?.data : conceptRes?.data?.items) || []
    conceptData.value = normalizeFourParts(conceptRaw)
    const gateRaw = (Array.isArray(fullRes?.data) ? fullRes?.data : fullRes?.data?.items) || []
    fullGateData.value = gateRaw.map((it: any) => ({
      name: String(it?.name ?? ''),
      onTrack: Number(it?.onTrack ?? 0),
      overDue: Number(it?.overDue ?? 0),
    }))
  } catch {}
  finally {
    fourPartsLoading.value = false
    conceptLoading.value = false
    fullGateLoading.value = false
  }
}

const debouncedTrigger = debounce(triggerApis, 400)
watch(
  selectedQuarters,
  (nv) => {
    const contiguous = ensureContiguous(nv)
    if (nv.length !== contiguous.length || nv.some((q, i) => q !== contiguous[i])) {
      selectedQuarters.value = contiguous
      return
    }
    if (contiguous.length) {
      const ids = contiguous.map((q) => quarters.indexOf(q)).filter((i) => i >= 0)
      const min = Math.min(...ids)
      const max = Math.max(...ids)
      const cur = sliderRange.value
      if (cur[0] !== min || cur[1] !== max) sliderRange.value = [min, max]
    } else {
      sliderRange.value = [0, 0]
    }
    if (isDragging.value) return
    debouncedTrigger()
  },
  { deep: true },
)

watch(
  sliderRange,
  (nv) => {
    const [a, b] = nv
    const s = Math.min(a, b)
    const e = Math.max(a, b)
    const next = quarters.slice(s, e + 1)
    const cur = selectedQuarters.value
    const same = next.length === cur.length && next.every((q, i) => q === cur[i])
    if (!same) selectedQuarters.value = next
  },
  { deep: true },
)

const onSliderStart = () => {
  isDragging.value = true
}

const onSliderEnd = () => {
  isDragging.value = false
  const [a, b] = sliderRange.value
  const s = Math.min(a, b)
  const e = Math.max(a, b)
  const next = quarters.slice(s, e + 1)
  const cur = selectedQuarters.value
  const same = next.length === cur.length && next.every((q, i) => q === cur[i])
  if (!same) selectedQuarters.value = next
  debouncedTrigger()
}

onMounted(async () => {
  try {
    const res = await permitAccount()
    if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
      sessionStorage.setItem('user_account_group', res.data.join(','))
    } else {
      sessionStorage.setItem('user_account_group', '')
    }
  } catch {}
  selectedQuarters.value = [...quarters]
  sliderRange.value = [0, 3]
  if (chartEl.value) {
    nextTick(() => {
      chart = echarts.init(chartEl.value)
      resizeHandler = () => chart && chart.resize()
      window.addEventListener('resize', resizeHandler)
    })
  }
})

onBeforeUnmount(() => {
  if (resizeHandler) window.removeEventListener('resize', resizeHandler)
  if (chart) {
    chart.dispose()
    chart = null
  }
})
</script>

<style scoped>
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
/* 预留底部安全区域，避免被 Tabbar 遮挡 */
.pb-tabbar-safe {
  padding-bottom: calc(env(safe-area-inset-bottom) + var(--van-tabbar-height));
}
@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.animate-slide-up {
  animation: slideUp 0.6s ease-out forwards;
}
</style>
